import { PTA_BANNER_HEIGHT, SEVERITY_LEVELS } from 'Util/constants'
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus'
import PublicIcon from '@mui/icons-material/Public'
import { Alert } from '@mui/material'
import { styled } from '@mui/material/styles'
import { t } from 'ttag'

interface PTABannerProps {
  selectedPta: string
  isGlobalSection?: boolean
}

const StyledBanner = styled(Alert)(() => ({
  height: PTA_BANNER_HEIGHT,
  borderRadius: 0,
  alignItems: 'center',
  justifyContent: 'center',
  '& .MuiSvgIcon-root': {
    fontSize: '1.25rem'
  }
}))

export default function PTABanner({
  selectedPta,
  isGlobalSection = false
}: Readonly<PTABannerProps>) {
  const ALERT_CONFIG = {
    global: {
      icon: PublicIcon,
      severity: SEVERITY_LEVELS.LEARN,
      message: t`Global section for all authorities`
    },
    ptaSpecific: {
      icon: DirectionsBusIcon,
      severity: SEVERITY_LEVELS.INFO,
      message: selectedPta
    }
  } as const
  const config = isGlobalSection ? ALERT_CONFIG.global : ALERT_CONFIG.ptaSpecific
  const IconComponent = config.icon
  return (
    <StyledBanner
      icon={<IconComponent />}
      severity={config.severity}
      elevation={0}
      variant="filled"
    >
      {config.message}
    </StyledBanner>
  )
}
